var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#49AE9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.15 12.75H15.3625C12.875 12.75 11.625 14.0125 11.625 16.525V36.5H18.375V31.8125C18.375 31.5639 18.4738 31.3254 18.6496 31.1496C18.8254 30.9738 19.0639 30.875 19.3125 30.875C19.5611 30.875 19.7996 30.9738 19.9754 31.1496C20.1512 31.3254 20.25 31.5639 20.25 31.8125V36.5H26.875V16.525C26.875 14.0125 25.6375 12.75 23.15 12.75ZM22.4375 24.9375H16.25C15.7375 24.9375 15.3125 24.5125 15.3125 24C15.3125 23.4875 15.7375 23.0625 16.25 23.0625H22.4375C22.95 23.0625 23.375 23.4875 23.375 24C23.375 24.5125 22.95 24.9375 22.4375 24.9375ZM22.4375 20.25H16.25C15.7375 20.25 15.3125 19.825 15.3125 19.3125C15.3125 18.8 15.7375 18.375 16.25 18.375H22.4375C22.95 18.375 23.375 18.8 23.375 19.3125C23.375 19.825 22.95 20.25 22.4375 20.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 35.5639H34.9125V31.8139C36.1 31.4264 36.9625 30.3139 36.9625 29.0014V26.5014C36.9625 24.8639 35.625 23.5264 33.9875 23.5264C32.35 23.5264 31.0125 24.8639 31.0125 26.5014V29.0014C31.0125 30.3014 31.8625 31.4014 33.025 31.8014V35.5639H10.25C9.7375 35.5639 9.3125 35.9889 9.3125 36.5014C9.3125 37.0139 9.7375 37.4389 10.25 37.4389H33.9125C33.9375 37.4389 33.95 37.4514 33.975 37.4514C34 37.4514 34.0125 37.4389 34.0375 37.4389H37.75C38.2625 37.4389 38.6875 37.0139 38.6875 36.5014C38.6875 35.9889 38.2625 35.5639 37.75 35.5639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.0230206a6980eee8c2fcaecc74a7d796.svg";
export { ForwardRef as ReactComponent };